// removed by extract-text-webpack-plugin
module.exports = {"DialogContainer":"_1tiRWG9AM_rCyY-OpKqVAr","DialogContainer__close":"_3hwxDtW0RZc8jGo4txOoJP","DialogContainer--appear":"_2sSNAOqorxyU6d3jpam3Jw","DialogContainer--appear-active":"qPQ-WKeFG1VrMRcNyTCtR","DialogContainer--leave":"_78M2MakTtWdoywb5_O3ad","DialogContainer--leave-active":"_17QFYBpJoRgWNVzQ-s2EAL"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DialogContainer/DialogContainer.scss
// module id = 2639
// module chunks = 0